class ThisFits extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('[data-variant-toggle]').forEach(button => {
            button.addEventListener('click', e => {
                let content = e.target.parentElement.querySelector('.variant-fits__content');
                if (content.style.display == "none" || content.style.display == "") {
                    content.style.display = "block"
                    e.target.parentElement.querySelector('button').classList.add('expanded')
                }
                else {
                    content.style.display = "none"
                     e.target.parentElement.querySelector('button').classList.remove('expanded')
                }

            })
        })
    }

}
customElements.define('variant-fits', ThisFits);